import { useEffect } from 'react';

/**
 * Board → case deep link (T-186): /funerals/:id/show?focus=<anchor> scrolls
 * to the element marked data-notes-anchor="<anchor>" and briefly outlines it,
 * like the Notes card's jump. Returns the anchor so a section can also open
 * its own panel (e.g. OAS).
 */
export function focusParam(): string | null {
  try {
    return new URLSearchParams(window.location.search).get('focus');
  } catch {
    return null;
  }
}

export function useFocusAnchor(anchor: string, onFocus?: () => void): void {
  useEffect(() => {
    if (focusParam() !== anchor) return;
    const t = window.setTimeout(() => {
      const el = document.querySelector<HTMLElement>(`[data-notes-anchor="${anchor}"]`);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'center' });
        const prev = el.style.boxShadow;
        el.style.transition = 'box-shadow 0.25s';
        el.style.boxShadow = '0 0 0 3px rgb(47 91 214), 0 0 0 7px rgb(47 91 214 / 0.18)';
        window.setTimeout(() => {
          el.style.boxShadow = prev;
        }, 2200);
      }
      onFocus?.();
    }, 600);
    return () => window.clearTimeout(t);
    // Once per page load: the param doesn't change while the page is open.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
